module.exports = __webpack_public_path__ + "img/imageSearch.071fda12.png";